module.exports = __webpack_public_path__ + "static/media/yokitup.45297779.png";